/*
 * cddinvis: Class to handle management of cdds that are in vis format
  Copyright (c) 2025 Quantellia LLC.  All Rights Reserved.
*/

// import $ from 'jquery';
import { parseJson } from "../../shared.js";

// Note that all-lowercase is so that the file name matches the class name,
// and all-lc is best practice for file names that may live on both windows and *nix
//
// TODO cddinvis and cddinodi should polymorphically inherit from a parent class to avoid
// some of the method redundancy that you see here.
//

export class cddinvis {
  constructor(data) {
    if (data)
      this.data = data;
  }

  toJSON() {
    return this.data;
  }

  parse() {
    // Parse the data
    // TODO complete this stub
    alert("model parse");
  }

  validate() {
    // Validate the model
    // TODO complete this stub
    alert("model validate");
  }
async read() {
    return new Promise((resolve, reject) => {
      const fileInput = document.createElement("input");
      fileInput.type = "file";

      fileInput.addEventListener("change", (event) => {
        const selectedFile = event.target.files[0];

        if (selectedFile) {
          const fileReader = new FileReader();

          fileReader.onload = (event) => {
           var dataInStringForm = event.target.result;
           const jsonData = parseJson(dataInStringForm);

           if (jsonData) {
             this.data = jsonData; // Attach data to the instance
             // this.data = event.target.result; // Attach data to the instance
              resolve();
            }
            else {
              reject(new Error('Failed to parse data from vis file'));
            }
          };

          fileReader.readAsText(selectedFile);
        }
      });

      fileInput.click();
    });
  }

  async write() {
    if (!this.data) {
      // TODO needs better error handling
      console.log("No cdd data to write");
      return;
    }

    return new Promise((resolve, reject) => {
      const dataToWrite = this.data; 

      if (dataToWrite) {
        
        // TODO note that there's an inconsistency: in vis, this.data is stored as an object,
        // so it has to be converted to a string before it's written.  In odi, this.data is
        // stored as a string.
        const dataInStringForm = JSON.stringify(dataToWrite);

        // const blob = new Blob([dataToWrite], { type: "text/plain" });
        const blob = new Blob([dataInStringForm], { type: "text/plain" });

        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "mymodel.worldmodeler"; 

        a.addEventListener("click", () => {
          setTimeout(() => {
            URL.revokeObjectURL(a.href);
          }, 150); // Revoke the object URL after a short delay to ensure the file is downloaded

          resolve();
        });

        a.click();
      } else {
        reject("No data to write.");
      }
    });
  }

  transform() {
    // Transform the model
    alert("model transform");
  }

  // TODO may belong in a diView component, not here
  render() {
    // Render the model
    alert("model render");
  }
}

///
// Utilities
///

// When the CDD changes, we need to set up the model object so that it can be used for export later
export function initializeModelObject(modelData) {
  visCDD = new cddinvis(modelData);
}